import './slabs-section.scss';

export default () => {
};
